import { AxiosRequestConfig } from "axios";
import { ApiTokenGetResponse } from "../models/apiTokenGetResponse";
import ApiRequestBase from "./apiRequestBase";

/**
 * ApiToken取得のデータアクセス周りを司るclass。
 */
export default class ApiTokenApiRequest {
	/**
	 * [GET]ApiTokenを取得。
	 * @returns apiToken
	 */
	public async getApiToken(tenantId: string): Promise<ApiTokenGetResponse> {
		// リクエストの設定
		const options: AxiosRequestConfig = {
			url: `${process.env.VUE_APP_HTTP_API_ENDPOINT}/apitoken`,
			headers: {
				tenantId: tenantId,
			},
			method: "GET",
		};

		return (await ApiRequestBase.request<ApiTokenGetResponse>(options)) as ApiTokenGetResponse;
	}
}
